(() => {
  function format(root = document) {
    root.querySelectorAll('[data-editorial-content]:not([data-formatted])').forEach(content => {
      content.dataset.formatted = 'true';
      content.querySelectorAll('[style],[width],[height]').forEach(el => { el.removeAttribute('style'); el.removeAttribute('width'); el.removeAttribute('height'); });
      if (content.hasAttribute('data-text-only')) content.querySelectorAll('img,picture').forEach(el => el.remove());
      const nav = content.closest('.pe-layout')?.querySelector('[data-content-nav]');
      content.querySelectorAll('h1,h2,h3,h4').forEach((heading, index) => {
        heading.id ||= `content-${content.id || 'page'}-${index}`;
        if (!nav || !heading.textContent.trim()) return;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        nav.append(link);
      });
      if (nav && !nav.children.length) nav.hidden = true;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => format()); else format();
  document.addEventListener('shopify:section:load', event => format(event.target));
})();
